<div class="mg-t-20 ">

  @if (pager.pages && pager.pages.length > 1) {
    <ul class="pagination mg-b-0">
      @if (currentPageNr != 1) {
        <li class="clickable page-item d-none d-sm-block" class.disabled="currentPageNr === 1">
          <a class="page-link"(click)="setPage(1)" aria-label="First"><i class="fa fa-angle-double-left"></i></a>
        </li>
      }
      @for (page of pager.pages; track page; let idx = $index) {
        <li class="clickable page-item"  [class.active]="currentPageNr === page">
          <a class="page-link" (click)="setPage(page)">{{page}}</a>
        </li>
      }
      @if (currentPageNr != pager.totalPages) {
        <li class="clickable page-item d-none d-sm-block" >
          <a class="page-link" (click)="setPage(pager.totalPages)"><i class="fa fa-angle-double-right"></i></a>
        </li>
      }
    </ul>
  }

</div>
